import axios from "~/axios";

export default {
  state: {
    vocabularies: null,
    currentVocabulary: null,
    breadcrumbs: [],
  },
  getters: {
    vocabularies(state) {
      return state.vocabularies;
    },
    breadcrumbs(state) {
      return state.breadcrumbs;
    },
  },
  actions: {
    async getVocabularies({ commit }) {
      const { data: mainVocabularies } = await axios.get("/metadata/study-vocabularies/");
      const totalDocuments = mainVocabularies.reduce((sum, vocabulary) => sum + vocabulary.frequency, 0);
      const mainVocabulariesParent = {
        id: 0,
        value: "all",
        frequency: totalDocuments,
        translation: { en: "All professional vocabularies", nl: "Alle vakvocabulaires" },
      };
      commit("SET_VOCABULARIES", { current: mainVocabulariesParent, childeren: mainVocabularies });
    },
    async getVocabulary({ commit, dispatch }, vocabulary) {
      if (vocabulary.id == 0) {
        dispatch("getVocabularies");
      } else {
        const { data: childeren } = await axios.get("/metadata/study-vocabularies/?parent=" + vocabulary.id);
        commit("SET_VOCABULARIES", { current: vocabulary, childeren });
      }
    },
  },
  mutations: {
    SET_VOCABULARIES(state, payload) {
      state.vocabularies = payload.childeren;
      const index = state.breadcrumbs.findIndex((obj) => obj.id === payload.current.id);
      if (index !== -1) {
        state.breadcrumbs.splice(index + 1);
      } else {
        state.breadcrumbs.push(payload.current);
      }
    },
  },
};
